var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.666 86.0002C157.666 125.581 125.58 157.667 85.9997 157.667C46.4193 157.667 14.333 125.581 14.333 86.0002C14.333 46.4198 46.4193 14.3335 85.9997 14.3335C125.58 14.3335 157.666 46.4198 157.666 86.0002Z",
    stroke: "url(#paint0_linear_57_352)",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9997 46.5836V57.3336M85.9997 57.3336C75.1151 57.3336 66.2914 63.9889 66.2914 72.1982C66.2914 80.4075 71.6664 84.9389 85.9998 84.9389C100.333 84.9389 107.5 89.1859 107.5 99.8031C107.5 110.42 97.8739 114.667 85.9997 114.667M85.9997 57.3336C96.8844 57.3336 105.708 63.9889 105.708 72.1982M85.9997 114.667V125.417M85.9997 114.667C74.1256 114.667 64.4998 108.012 64.4998 99.8031",
    stroke: "url(#paint1_linear_57_352)",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_352",
    x1: 26.0816,
    y1: 57.6913,
    x2: 155.363,
    y2: 52.0088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_352",
    x1: 68.0243,
    y1: 70.4304,
    x2: 106.861,
    y2: 69.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D25C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8C00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.973234a78d283be7b6f2dce5e8e9c2a9.svg";
export { ForwardRef as ReactComponent };